<template>
    <Skeleton class="flex flex-col">
        <div class="mb-0.5">
            <div class="skeleton-item-block h-16 w-full" />
        </div>
        <div class="flex items-center gap-0.5">
            <div class="skeleton-item-block h-12 w-40" />
            <div class="skeleton-item-block h-12 w-full" />
        </div>
        <div class="w-full px-4 lg:16 2xl:px-40 3xl:px-64 pt-6 pb-5 flex-grow">
            <div class="lg:grid lg:grid-cols-5 gap-8 h-full">
                <div class="col-span-2 flex flex-col gap-3">
                    <div class="skeleton-item-block h-16 w-full rounded-md" />
                    <div class="skeleton-item-block h-16 w-full rounded-md" />
                    <div class="skeleton-item-block h-16 w-full rounded-md" />
                    <div class="skeleton-item-block h-16 w-full rounded-md" />
                    <div class="skeleton-item-block h-16 w-full rounded-md" />
                </div>
                <div class="col-span-3 flex flex-col gap-8">
                    <div class="flex-grow">
                        <div class="skeleton-item-block w-full h-full min-h-56 rounded-md" />
                    </div>
                    <div class="flex justify-end items-center gap-3">
                        <div class="skeleton-item-block w-38 h-10 rounded-md" />
                        <div class="skeleton-item-block w-38 h-10 rounded-md" />
                    </div>
                </div>
            </div>
        </div>
    </Skeleton>
</template>

<script setup lang="ts">
import Skeleton from '@/components/RedesignBaseComponents/Loader/Skeleton.vue'
</script>

